import React from "react";
import { Card } from 'antd';

import ServiceRequestsTable from 'components/ServiceRequestsTable/ServiceRequestsTable';

const ServiceRequests = () => {
	document.title = 'Заявки | Archi-crm';

	return (
		<div className="page-content">
			<div className="container-fluid">
				<Card>
					<ServiceRequestsTable />
				</Card>
			</div>
		</div>
	)
}

export default ServiceRequests;
